import { ManagementWebhookEventRepository } from '@domain/management-webhook-event/repositories/management-webhook-event.repository';
import { ManagementWebhookEventRepositoryService } from '../repositories/management-webhook-event.service';

export const ManagementWebhookEventProvider = [
  {
    provide: ManagementWebhookEventRepository,
    useClass: ManagementWebhookEventRepositoryService,
  },
];
